module.exports = __webpack_public_path__ + "img/mullins-ringed-city.7855db57.jpg";